import { addDays, fromUnixTime, getUnixTime, isAfter } from 'date-fns';
import { z } from 'zod';

const restoredState = z.object({
  expiration: z.number(),
  data: z.any()
});

export function tryRestoreStateFromStorage<T>(
  key: string | string[],
  initialState: T
): T {
  const cacheKey = Array.isArray(key) ? key.join('-') : key;
  try {
    const serialisedState = localStorage.getItem(cacheKey);
    if (serialisedState === null) return initialState;
    const saveData = JSON.parse(serialisedState);

    restoredState.parse(saveData);

    if (isAfter(new Date(), fromUnixTime(saveData.expiration))) {
      throw new Error(`The state has expired. ${JSON.stringify(saveData)}`);
    }
    return saveData.data as T;
  } catch (error) {
    localStorage.removeItem(cacheKey);
    console.log({
      error: error,
      status: 'Restoring initial state'
    });
    return initialState;
  }
}

export function saveStateToStorage(key: string | string[], data: any) {
  const cacheKey = Array.isArray(key) ? key.join('-') : key;
  try {
    const saveData = {
      expiration: getUnixTime(addDays(new Date(), 2)),
      data
    };

    localStorage.setItem(cacheKey, JSON.stringify(saveData));
  } catch (error) {
    console.log(`[saveStateToStorage] Error when persisting state ${error}`);
  }
}
